//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class MembershipClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    example(): Promise<any> {
        let url_ = this.baseUrl + "/api/membership/example";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExample(_response);
        });
    }

    protected processExample(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getUserMembership(userId: string | null): Promise<GetUserMembership_Response> {
        let url_ = this.baseUrl + "/api/membership/user/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserMembership(_response);
        });
    }

    protected processGetUserMembership(response: Response): Promise<GetUserMembership_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserMembership_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserMembership_Response>(null as any);
    }

    /**
     * @return Success
     */
    serviceInvocationExample(): Promise<any> {
        let url_ = this.baseUrl + "/api/membership/service-invocation-example";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processServiceInvocationExample(_response);
        });
    }

    protected processServiceInvocationExample(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    startCancellation(request: StartCancellation_Request, userId: string): Promise<StartCancellation_Response> {
        let url_ = this.baseUrl + "/api/membership/user/{UserId}/cancel";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartCancellation(_response);
        });
    }

    protected processStartCancellation(response: Response): Promise<StartCancellation_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartCancellation_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartCancellation_Response>(null as any);
    }

    /**
     * @return Success
     */
    stripeWebhook(request: StripeWebhook_Request, stripe_Signature: string | null): Promise<any> {
        let url_ = this.baseUrl + "/api/membership/stripe-webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Stripe-Signature": stripe_Signature !== undefined && stripe_Signature !== null ? "" + stripe_Signature : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStripeWebhook(_response);
        });
    }

    protected processStripeWebhook(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class GetUserMembership_Response implements IGetUserMembership_Response {
    hasMembership?: boolean;
    membership?: GetUserMembership_Response_MembershipResponse | undefined;

    constructor(data?: IGetUserMembership_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMembership = _data["hasMembership"];
            this.membership = _data["membership"] ? GetUserMembership_Response_MembershipResponse.fromJS(_data["membership"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserMembership_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserMembership_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMembership"] = this.hasMembership;
        data["membership"] = this.membership ? this.membership.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserMembership_Response {
    hasMembership?: boolean;
    membership?: GetUserMembership_Response_MembershipResponse | undefined;
}

export class GetUserMembership_Response_MembershipResponse implements IGetUserMembership_Response_MembershipResponse {
    stripeCustomerId?: string | undefined;
    startedOn?: Date;
    renewalPeriod?: GetUserMembership_Response_MembershipResponse_RenewalPeriodResponse;
    cancellation?: GetUserMembership_Response_MembershipResponse_CancelledMembershipResponse | undefined;

    constructor(data?: IGetUserMembership_Response_MembershipResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>undefined;
            this.renewalPeriod = _data["renewalPeriod"];
            this.cancellation = _data["cancellation"] ? GetUserMembership_Response_MembershipResponse_CancelledMembershipResponse.fromJS(_data["cancellation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserMembership_Response_MembershipResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserMembership_Response_MembershipResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["renewalPeriod"] = this.renewalPeriod;
        data["cancellation"] = this.cancellation ? this.cancellation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserMembership_Response_MembershipResponse {
    stripeCustomerId?: string | undefined;
    startedOn?: Date;
    renewalPeriod?: GetUserMembership_Response_MembershipResponse_RenewalPeriodResponse;
    cancellation?: GetUserMembership_Response_MembershipResponse_CancelledMembershipResponse | undefined;
}

export enum GetUserMembership_Response_MembershipResponse_RenewalPeriodResponse {
    Monthly = 0,
    Annual = 1,
}

export class GetUserMembership_Response_MembershipResponse_CancelledMembershipResponse implements IGetUserMembership_Response_MembershipResponse_CancelledMembershipResponse {
    cancelledOn?: Date;
    willEndOn?: Date;

    constructor(data?: IGetUserMembership_Response_MembershipResponse_CancelledMembershipResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancelledOn = _data["cancelledOn"] ? new Date(_data["cancelledOn"].toString()) : <any>undefined;
            this.willEndOn = _data["willEndOn"] ? new Date(_data["willEndOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserMembership_Response_MembershipResponse_CancelledMembershipResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserMembership_Response_MembershipResponse_CancelledMembershipResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancelledOn"] = this.cancelledOn ? this.cancelledOn.toISOString() : <any>undefined;
        data["willEndOn"] = this.willEndOn ? this.willEndOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetUserMembership_Response_MembershipResponse_CancelledMembershipResponse {
    cancelledOn?: Date;
    willEndOn?: Date;
}

export class StartCancellation_Response implements IStartCancellation_Response {
    stripeDashboardUrl?: string | undefined;

    constructor(data?: IStartCancellation_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stripeDashboardUrl = _data["stripeDashboardUrl"];
        }
    }

    static fromJS(data: any): StartCancellation_Response {
        data = typeof data === 'object' ? data : {};
        let result = new StartCancellation_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stripeDashboardUrl"] = this.stripeDashboardUrl;
        return data;
    }
}

export interface IStartCancellation_Response {
    stripeDashboardUrl?: string | undefined;
}

export class StartCancellation_Request implements IStartCancellation_Request {
    returnUrl?: string | undefined;

    constructor(data?: IStartCancellation_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): StartCancellation_Request {
        data = typeof data === 'object' ? data : {};
        let result = new StartCancellation_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IStartCancellation_Request {
    returnUrl?: string | undefined;
}

export class StripeWebhook_Request implements IStripeWebhook_Request {
    content?: string | undefined;

    constructor(data?: IStripeWebhook_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): StripeWebhook_Request {
        data = typeof data === 'object' ? data : {};
        let result = new StripeWebhook_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data;
    }
}

export interface IStripeWebhook_Request {
    content?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}